import { Component } from '@angular/core';

@Component({
  selector: 'htc-status-complete',
  templateUrl: './status-complete.component.html',
  styleUrls: ['../progress-node/progress-node.component.scss'],
})
export class StatusCompleteComponent {
  readonly path = '/assets/progress-node-icons/';
  readonly imageUrl = 'complete.svg';

  constructor() {}
}
